import FilterI from '../types.ts';

const setSizeInit: FilterI['setSizeInit'] = function () {
    this.setState({ isSizeInit: true });
};

export default setSizeInit;
